import mainCaller from './mainCaller';

// 수업·상담 관리 > 상담 목록·결과 변경·통계
const authHeaders = token => ({
  Authorization: `Bearer ${token}`,
  'Content-type': 'application/json',
});

const toQuery = params => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== '' && value != null) query.append(key, value);
  });
  return query.toString();
};

export async function getConsultManageList(params, token) {
  return await mainCaller(`admin/api/v1/consultations/manage?${toQuery(params)}`, 'GET', null, authHeaders(token));
}

export async function exportConsultManageList(params, token) {
  return await mainCaller(`admin/api/v1/consultations/manage/export?${toQuery(params)}`, 'GET', null, authHeaders(token));
}

export async function getConsultManagers(branchId, token) {
  return await mainCaller(`admin/api/v1/consultations/manage/managers?branchId=${branchId}`, 'GET', null, authHeaders(token));
}

export async function changeConsultResult(branchId, data, token) {
  return await mainCaller(`admin/api/v1/consultations/manage/result?branchId=${branchId}`, 'PUT', data, authHeaders(token));
}

export async function getConsultStats(branchId, month, token) {
  return await mainCaller(
    `admin/api/v1/consultations/manage/stats?branchId=${branchId}&month=${month}`,
    'GET',
    null,
    authHeaders(token),
  );
}
